import React from 'react';
import { CommonEmbed } from 'components/common/CommonEmbed';

export const Inquiry: React.FC = () => {
    return <CommonEmbed title="1:1 문의하기" path="/qna/create" />;
};
